import { ValidationError, ValidationErrors } from ".";
import { inject, computed, ComputedRef, ref } from "vue";

export interface useValidationErrorReturn {
  resetValidation: () => void;
  validationError: ComputedRef<ValidationError | undefined>;
}

export function useValidationError(
  fullPath?: string,
): useValidationErrorReturn {
  const validationErrors = ref(
    inject<ValidationErrors>("validationErrors", {}),
  );
  const resetValidationError = inject<(path: string) => void>(
    "resetValidationError",
  );

  /**
   * Return a validation error for a given property fullPath.
   */
  const validationError = computed(() => {
    return fullPath ? validationErrors.value[fullPath] : undefined;
  });

  /**
   * Reset the validation error for the given fullPath
   */
  const resetValidation = () => {
    if (fullPath && validationErrors.value[fullPath] && resetValidationError) {
      resetValidationError(fullPath);
    }
  };

  return {
    resetValidation,
    validationError,
  };
}
